import { render, staticRenderFns } from "./UsuarioInterno.vue?vue&type=template&id=127bae4d"
import script from "./UsuarioInterno.vue?vue&type=script&lang=js"
export * from "./UsuarioInterno.vue?vue&type=script&lang=js"
import style0 from "./UsuarioInterno.vue?vue&type=style&index=0&id=127bae4d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports